const CONST = require('./constants');

module.exports = {

    getBrand() {
        return Odigeo.SessionScope.brand;
    },

    getSite() {
        const website = Odigeo.SessionScope.website;
        return website.length === 4
            ? website
            : Odigeo.SessionScope.brand + website;
    },

    buildAirlinesMap: (config) => {
        return CONST.AIRLINES.MAP_CONFIG.reduce((airlinesMap, group) => {
            const airlinesListString = config[`${CONST.AIRLINES.KEY_PREFIX}${group}`];
            const settingAirlinesList = airlinesListString.split(CONST.AIRLINES.SPLIT_BY);
            const settingAirlinesMap = settingAirlinesList.reduce((acc, airline) => {
                acc[airline] = group;
                return acc;
            }, {});

            return {...airlinesMap, ...settingAirlinesMap};
        }, {});
    },

    openExternalLink(link) {
        window.open(
            link,
            '_blank'
        );
    },

    /**
     *
     * @param {Object} section - with all the section data
     * @param {string} tripType
     * @param {Object[]} segments - with all the booking itinerary segments
     * @param {Object} keys - with the translations
     * @return {string} - with the section name (e.g. departure, return...)
     */
    getSectionName(section, tripType, segments, keys) {
        const {sectionSegmentIndex, moreThanOneSectionInSegment, sectionIndexInSegment} = this.getSectionSegmentData(segments, section.id);
        let sectionName;
        switch (tripType) {
            case CONST.TRIP_TYPES.ONE_WAY:
                sectionName = `${keys['flightNumb'+section.id]}`;
                break;

            case CONST.TRIP_TYPES.ROUND_TRIP:
                sectionName = sectionSegmentIndex === 0 ?
                    `${keys.itineraryStatusDeparture}` :
                    `${keys.itineraryStatusReturn}`;

                sectionName += `${moreThanOneSectionInSegment ? keys['flightNumb'+sectionIndexInSegment] : ''}`;
                break;

            case CONST.TRIP_TYPES.MULTI_SEGMENT:
                sectionName = `${keys['flightNumb'+sectionSegmentIndex]} ${keys['flightNumb'+sectionIndexInSegment]}`;
                break;
        }

        return sectionName;
    },

    /**
     *
     * @param {Object} segments - with all the booking itinerarySegments
     * @param {number} sectionId - with the section Id, which matches with the global section index
     * @return {{sectionIndexInSegment: number, sectionSegmentIndex: number, moreThanOneSectionInSegment: boolean}}
     */
    getSectionSegmentData(segments, sectionId) {
        let sectionSegmentIndex = 0;
        let moreThanOneSectionInSegment = false;
        let sectionIndexInSegment = 0;
        segments.forEach((segment, segmentIndex) => {
            segment.sections.forEach((section, index) => {
                if (section.id === sectionId) {
                    sectionSegmentIndex = segmentIndex;
                    moreThanOneSectionInSegment = segment.sections.length > 1;
                    sectionIndexInSegment = index;
                }
            });
        });
        return {sectionSegmentIndex, moreThanOneSectionInSegment, sectionIndexInSegment};
    },
};
